import { Grid } from '@mui/material'
import React from 'react'
import "./Emailwelcome.css"


function Emailwelcome() {
    return (
        <Grid container style={{padding:"30px"}}>
            <title>success</title>
            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
              <img width="100%" src="https://i.postimg.cc/rpgbWBMH/emailimage.png"/> 
            </Grid>
            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                 <a className="gotohome" href="/resume">Click here and go to home page</a>
           </Grid>
            
        </Grid>
      
    )
}

export default Emailwelcome
